import React from 'react'

const DataDescriptionDoc = () => {
  return (
    <div className='container'>
        <h1 className='text-light text-center'>Data Descriptions</h1>

      <p className='text-light'>
        MLGUI (Machine Learning Graphical User Interface) is a web-based tool designed for students and developers to easily create and run machine learning models without the need for coding. It provides a user-friendly interface that allows users to upload their own data, select from pre-defined models, and run them with just a few clicks. The tool also includes visualization features to help users understand and analyze their results. It's good for students and developers who want to get started with machine learning without prior experience in coding, but also for developers who want to quickly test their models and data.
    </p>
    </div>
  )
}

export default DataDescriptionDoc
